export default __webpack_public_path__ + "static/media/savings.7f894f88.svg";